import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSkipIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.25 3.75V14.25M5.69963 13.4403L10.0787 9.93704C10.4791 9.61673 10.6793 9.45658 10.7518 9.2631C10.8153 9.09346 10.8153 8.90654 10.7518 8.7369C10.6793 8.54342 10.4791 8.38326 10.0787 8.06296L5.69963 4.55971C5.07551 4.0604 4.76344 3.81075 4.50081 3.81047C4.2724 3.81022 4.05633 3.91407 3.91384 4.09258C3.75 4.29784 3.75 4.69747 3.75 5.49675V12.5033C3.75 13.3025 3.75 13.7022 3.91384 13.9074C4.05633 14.0859 4.2724 14.1898 4.50081 14.1895C4.76344 14.1892 5.07551 13.9396 5.69963 13.4403Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgSkipIcon;
